'use strict';var _desc,_value,_class;function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const pulsarDate=require('pulsar-utils/dist-es6/pulsarDate');
const Formatters=require('../../../../dist-es6/client/formatters');
const ThresholdStatus=require('pulsar-dashboard-core/dist-es6/domain/thresholdStatus');
const NotificationType=require('pulsar-dashboard-core/dist-es6/domain/notificationType');
const BaseRealtimeUpdateController=require('../../../../dist-es6/client/angularCommon/baseRealtimeUpdateController');
const{UpdateFailedError}=BaseRealtimeUpdateController;
const{SocketTimeoutError,UnexpectedError}=require('../../../../dist-es6/client/services/socketService');
const ControllerExtensions=require('../../../../dist-es6/client/extensions/controllerExtensions');
const{HandleUncaughtErrors}=require('../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations;
const timespan=require('pulsar-utils/dist-es6/time/timespan');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const FatigueMeterType=require('pulsar-utils/dist-es6/domain/fatigueMeterType');

const ControllerDefaults={
stateName:'fdc.features.flightMonitor',
searchQuery:'',
maxSchedulesToDisplay:250,
selectedSchedule:null,
preventRealtimeDigests:!0};


const DefaultLookDuration=timespan.fromHours(12);
const DefaultNumFutureDaysInForecast=timespan.fromDays(7);
const DefaultVisibleRange=timespan.fromMilliseconds(DefaultLookDuration.totalMilliseconds()+DefaultNumFutureDaysInForecast.totalMilliseconds());let

FlightMonitorController=(_class=class FlightMonitorController extends BaseRealtimeUpdateController{
constructor(
$scope,
$state,
$timeout,
$interval,
$element,
dateService,
breadcrumbsService,
flightMonitorDataService,
userService,
Analytics,
uncaughtErrorHandler,
groupTreeService,
timeZoneService,
timeFormattingService,
paramSyncService,
displaySettingsService,
fatigueMeterTypeContentProviderService)
{
super(uncaughtErrorHandler,$scope,$timeout,$interval,dateService,timespan.fromMinutes(5),timespan.fromSeconds(1),timeZoneService);

const existingStickySettings={};

this._$timeout=$timeout;
this._$state=$state;
this._$element=$element;

this._uncaughtErrorHandler=uncaughtErrorHandler;
this._flightMonitorDataService=flightMonitorDataService;
this._userService=userService;
this._analytics=Analytics;
this._timeFormattingService=timeFormattingService;
this._displaySettingsService=displaySettingsService;
this._fatigueMeterTypeContentProviderService=fatigueMeterTypeContentProviderService;

this.currentTimeOverride=this._dateService.now();

this.selectedSchedule=null;
this.selectedScheduleAlertInfo=null;
this._othersWithSameFlight=[];
this.sidebarHeightRelevantData=[];
this.useRollingMode=!0;
this.useLocalTime=!0;

this._onRangeChanged=({start,end,event,byUser,force=!1})=>{
if(!byUser){
return;
}

this._lastVisibleRange=TimeInterval.from(start).to(end);
this._lastVisibleRangeUpdateTime=this._dateService.now();

if(!force&&this.queryInterval.contains(this._lastVisibleRange)){
return;
}

if(this.dataService.isUpdating){
this.dataService.clearCache();
}

this.startNextUpdate();
};

const forecastAreaHeight=angular.element('body').innerHeight()-84-41-14||400;

this.timelineOptions={
zoomable:!0,
zoomKey:'ctrlKey',
moveable:!0,
horizontalScroll:!1,
zoomMax:timespan.fromDays(28).totalMilliseconds(),
zoomMin:timespan.fromHours(12).totalMilliseconds(),
showMajorLabels:!0,
showMinorLabels:!0,
minHeight:425,
height:forecastAreaHeight,
verticalScroll:!0,
autoResize:!0,
format:{
minorLabels:{
millisecond:'SSS',
second:'s',
minute:'HH:mm',
hour:'HH:mm',
weekday:'ddd D',
day:'D',
week:'w',
month:'MMM',
year:'YYYY'},

majorLabels:{
millisecond:'HH:mm:ss',
second:'D MMMM HH:mm',
minute:'ddd D MMMM',
hour:'ddd D MMMM',
weekday:'MMMM YYYY',
day:'MMMM YYYY',
week:'MMMM YYYY',
month:'YYYY',
year:''}}};




_.defaults(this,existingStickySettings,ControllerDefaults);

breadcrumbsService.startTrail(this._fatigueMeterTypeContentProviderService.flightMonitorFeatureTitle);
groupTreeService.linkController(this);

this.visibleRangeOptions=[7].map(numFutureDays=>({numFutureDays,label:`Next ${numFutureDays} Days`}));

this.visibleRoleOptions=[{
label:'Flight Crew',
crewRoles:['PIC','pic','SIC','sic','PILOT','pilot',void 0]},
{
label:'Cabin Crew',
crewRoles:['FA','fa']}];

this.selectedVisibleRoles=[].concat(this.visibleRoleOptions);


this.visibleStatusOptions=[{
label:'any status',
hasMatchingFlight:schedule=>!0},
{
label:'any flights at',
statusIcon:'above-threshold',
hasMatchingFlight:person=>person.flights.length!==0&&person.flights.some(flight=>person.getThresholdStatusForFlight(flight)===ThresholdStatus.Above)},
{
label:'any flights at or above',
statusIcon:'at-threshold',
hasMatchingFlight:person=>person.flights.length!==0&&person.flights.some(flight=>{
const status=person.getThresholdStatusForFlight(flight);
return[ThresholdStatus.Above,ThresholdStatus.At].includes(status);
})},
{
label:'all flights at',
statusIcon:'below-threshold',
hasMatchingFlight:person=>person.flights.length!==0&&person.flights.every(flight=>person.getThresholdStatusForFlight(flight)===ThresholdStatus.Below)},
{
label:'no flights scheduled',
hasMatchingFlight:person=>person.flights.length===0}];

this.selectedVisibleStatusOption=_.first(this.visibleStatusOptions);

const label=this._displaySettingsService.stickySettings.get('selectedFlightMonitorVisibleRangeOptionLabel');
const stickyOption=_.find(this.visibleRangeOptions,{label});
this._setAndSaveSelectedVisibleRangeOption(_.exists(stickyOption)?stickyOption:_.first(this.visibleRangeOptions));

this._updateUrlParamsFromController=paramSyncService.start(this,$scope,newParams=>this._updateControllerParamsFromUrl(newParams));

if($state.params.groupId||$state.params.employeeId){
this._$timeout(()=>this._assignParamsToController($state.params));
}

this._$scope.$watch('controller.selectedSchedule',(newVal,oldVal)=>{
this._updateUrlParamsFromController({
personId:_.result(this.selectedSchedule,'id.toString')});


this.selectedFlight=null;

if(!_.exists(this.selectedSchedule)){
this.sidebarVisible=!1;
return;
}

this.sidebarVisible=!0;
this._updateSidebarHeightData();
});

const _debouncedCheckPartialGroupData=_.debounce(()=>{
const shouldReload=this.dataService.shouldReloadForLatestGroupData;
if(!_.exists(shouldReload)||!shouldReload){
return;
}

this.startNextUpdate();
},50);

this._$scope.$watch('controller.dataService.shouldReloadForLatestGroupData',()=>_debouncedCheckPartialGroupData());

this._$scope.$watchGroup([
'controller.selectedGroupData',
'controller.selectedVisibleRoles.length',
'controller.selectedVisibleStatusOption'],
()=>{
_debouncedCheckPartialGroupData();

const persons=_.get(this,'selectedGroupData.aggregatePersons',[]);
if(!persons.length){
this.flightMonitorSchedules=[];
this.selectedSchedule=null;
return;
}

this.flightMonitorSchedules=this._filterAndSort(persons);
const selectedScheduleId=_.result(this.selectedSchedule,'id.toString',this._$state.params.personId);
const newSelectedScheduleWithSameId=selectedScheduleId&&this.flightMonitorSchedules.find(s=>s.id.toString()===selectedScheduleId);

this._$scope.$evalAsync(()=>{
this.selectedSchedule=newSelectedScheduleWithSameId||null;

this._$timeout(()=>{

const scrollerElement=angular.element('.feature-main > .scroller-wrapper.flight-monitor-schedules');
if(!scrollerElement){
return;
}

scrollerElement.triggerHandler('mouseenter');

if(!newSelectedScheduleWithSameId){
scrollerElement.scrollTop(0);
}
});
});
});

this._$scope.$watch('controller.searchQuery',_.debounce(()=>{

this._$timeout(()=>{
const scrollerElement=angular.element('.feature-main > .scroller-wrapper.flight-monitor-schedules');
if(!scrollerElement){
return;
}

scrollerElement.triggerHandler('mouseenter');
scrollerElement.scrollTop(0);
});
},150));

this._$scope.$watch('controller.filteredSchedules',()=>{
if(!this.selectedSchedule){
return;
}

if(this.filteredSchedules&&this.filteredSchedules.length>0&&this.filteredSchedules.indexOf(this.selectedSchedule)!==-1){
return;
}

this._$scope.$evalAsync(()=>{
this.selectedSchedule=null;
});
});

this._$scope.$watch('controller.currentTimeOverride',_.debounce((newTime,oldTime)=>{
if(!this.currentTimeOverride){
return;
}

if(_.isEqual(newTime,oldTime)){
return;
}

const duration=_.exists(this._lastVisibleRange)?
this._lastVisibleRange.duration:
DefaultVisibleRange;

const differenceInMilliseconds=newTime.getTime()-oldTime.getTime();

const lookbackDurationInMilliseconds=duration.totalMilliseconds()*0.5;
const newRange=TimeInterval.from(this.currentTimeOverride.getTime()-lookbackDurationInMilliseconds).spanning(duration);

const newRangeOptions={
start:newRange.start,
end:newRange.end,
byUser:!0,
force:!0};


this._$scope.$evalAsync(()=>{
this._onRangeChanged(newRangeOptions);
});
},500));

this._$scope.$watch('controller.selectedFlight',()=>{
this._updateSidebarHeightData();

if(!this.selectedSchedule||!this.selectedFlight){
this._othersWithSameFlight=[];
return;
}

this._$scope.$evalAsync(()=>{
this._othersWithSameFlight=this.getOtherCrewWithSameFlight(this.selectedSchedule,this.selectedFlight);
});
});

this._beginUpdates();
}

_updateSelectedVisibleRangeOption(newOption){
this._setAndSaveSelectedVisibleRangeOption(newOption);
this.startNextUpdate();
}

_setAndSaveSelectedVisibleRangeOption(newOption){
this.selectedRangeOption=newOption;
this._displaySettingsService.stickySettings.set('selectedFlightMonitorVisibleRangeOptionLabel',this.selectedRangeOption.label);
}

_filterAndSort(persons){
let filteredPersons=_(persons).
sortBy([
p=>p.currentStatus.onDuty?0:1,
p=>p.currentStatus.onTrip?0:1,
p=>_.get(p,'currentStatus.thresholdStatus')===ThresholdStatus.Above?0:1,
p=>_.get(p,'currentStatus.thresholdStatus')===ThresholdStatus.At?0:1,
p=>_.get(p,'currentStatus.thresholdStatus')===ThresholdStatus.Below?0:1,
p=>p.combinedDuties&&p.combinedDuties.length>0?0:1,
p=>p.lastName.toLowerCase(),
p=>p.firstName.toLowerCase(),
p=>p.employeeId.toLowerCase(),
p=>-1*_.get(p,'currentStatus.fatigue',0)]);


if(this.selectedVisibleRoles.length!==this.visibleRoleOptions.length){
const allValidCrewRoles=new Set(_.flatMap(this.selectedVisibleRoles,'crewRoles'));
filteredPersons=filteredPersons.filter(p=>p.flights.some(f=>allValidCrewRoles.has(f.crewRole)));
}

filteredPersons=filteredPersons.filter(p=>this.selectedVisibleStatusOption.hasMatchingFlight(p));

return filteredPersons.value();
}

_assignParamsToController(params){
if(this.flightMonitorSchedules){
this.selectedSchedule=this.flightMonitorSchedules.find(s=>s.id.toString()===params.personId);
}
this._groupTreeService.selectGroupWithId(params.groupId);
}

_updateControllerParamsFromUrl(newStateParams){
let{groupId,personId}=newStateParams;

if(_.get(this.selectedGroup,'id')===groupId&&
_.get(this.selectedSchedule,'id')===personId){
return;
}

this._assignParamsToController(newStateParams);
}

getOtherCrewWithSameFlight(selectedSchedule,selectedFlight){
const foundFlightPersonPairs=[];

const selectedFlightMatcher=_.pick(selectedFlight,['origin','destination','start','end']);


const sameOriginAndDestination=(one,two,key)=>{
if(['origin','destination'].includes(key)){
return one.icao===two.icao;
}
};

for(const viewModel of this.flightMonitorSchedules){
if(viewModel===selectedSchedule){
continue;
}

for(const flight of viewModel.flights){
if(_.isMatchWith(flight,selectedFlightMatcher,sameOriginAndDestination)){
foundFlightPersonPairs.push({viewModel,flight});
}
}
}

return foundFlightPersonPairs;
}

_updateSidebarHeightData(){
this._$scope.$evalAsync(()=>{
this.sidebarHeightRelevantData=[
this.selectedFlight,
this.selectedSchedule,
..._.get(this.selectedSchedule,'flights',[])];

});
}

get othersWithSameFlight(){
return this._othersWithSameFlight;
}

get use24HourTimeline(){
return this._timeFormattingService.safeUse24HourTimelineSetting;
}

get groupTreeService(){
return this._groupTreeService;
}

set groupTreeService(groupTreeService){
this._groupTreeService=groupTreeService;
}

get dataService(){
return this._flightMonitorDataService;
}

get visibleTimeZone(){
return this.useLocalTime?this.localTimeZone:'UTC';
}

openCurrentDatePicker($mdMenu,$event){
this.calendarPickerReady=!1;
this._$timeout(()=>{
$mdMenu.open($event);
$event.preventDefault();

this._$timeout(()=>{
this.calendarPickerReady=!0;
},150);
},150);
}


async _update(){
try{
const{numFutureDays}=this.selectedRangeOption;
const visibleRange=this._lastVisibleRange||null;

let shiftedVisibleRange;
if(this.useRollingMode&&visibleRange){
const diffFromDataServiceInMs=this._dateService.now().getTime()-this.dataService.currentTime.getTime();
shiftedVisibleRange=TimeInterval.from(visibleRange.start.getTime()+diffFromDataServiceInMs).to(visibleRange.end.getTime()+diffFromDataServiceInMs);
}

await this.dataService.update({
numFutureDays,
visibleRange:shiftedVisibleRange||visibleRange});


if(shiftedVisibleRange){
this._lastVisibleRange=this.dataService.queryInterval;
}

}catch(err){
if(err instanceof SocketTimeoutError||err instanceof UnexpectedError){
throw new UpdateFailedError;
}
throw err;
}
}

get $state(){
return this._$state;
}

get $scope(){
return this._$scope;
}

get _lastFetchTime(){
return this._flightMonitorDataService.lastFetchTime;
}

get _isUpdating(){
return this._flightMonitorDataService.isUpdating;
}

get groupTree(){
return this._flightMonitorDataService.groupTree;
}

get estimatesAsOfTime(){
return this._flightMonitorDataService.estimatesAsOfTime;
}

get selectedGroup(){
return this._groupTreeService.selectedGroup;
}

get selectedGroupData(){
return this._flightMonitorDataService.selectedGroupData;
}

get currentTime(){
return this._flightMonitorDataService.currentTime;
}

get queryInterval(){
return this._flightMonitorDataService.queryInterval;
}

get localTimeZone(){
return this._timeZoneService.localTimeZone;
}},(_applyDecoratedDescriptor(_class.prototype,'_update',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_update'),_class.prototype)),_class);


module.exports=FlightMonitorController;
//# sourceMappingURL=flightMonitorController.js.map
